import React from 'react';

import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';
import { StateProvider } from './app/services/state/State';
import { initialState } from './app/services/state/initialState';
import { reducer } from './app/services/state/Reducer';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StateProvider initialState={initialState} reducer={reducer}>
    <App />
  </StateProvider>
);
reportWebVitals();
serviceWorker.register();

